import { CultureInfo } from "../../Models/Culture/CultureInfo";
import { AxLoad } from "../AxSystem/AxLoad";
import { LocalizationModule } from "../../Modules/Global/LocalizationModule";
import { ConfigDefinition, ConfigHelper } from "./Config/ConfigHelper";

export class PriceHelper {
    cultureInfo: CultureInfo;
    private localizationModule: LocalizationModule;
    private usedCurrencySymbol: string;

    constructor(cultureInfo: CultureInfo, checkCurrencySymbolConfig: boolean) {
        this.localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');

        if (cultureInfo == null || cultureInfo == undefined) {
            this.cultureInfo = this.localizationModule.getCultureInfo();
        } else {
            this.cultureInfo = cultureInfo;
        }

        this.usedCurrencySymbol = this.cultureInfo.CurrencySymbol;

        if (checkCurrencySymbolConfig) {
            ConfigHelper.getBoolConfigValue(ConfigDefinition.StoreCurrencyWebUseIsoSymbol, (currencyWebUseIsoSymbol) => {
                if (currencyWebUseIsoSymbol) {
                    this.usedCurrencySymbol = this.cultureInfo.CurrencySymbol;
                } else {
                    this.usedCurrencySymbol = this.cultureInfo.CurrencyName;
                }
            });
        }
    }

    GetPriceStringWithDecimalDivisorCalced(totalAmount: number): string {
        const calculatedPrice: number = totalAmount / this.localizationModule.getPriceToDecimalDivisor();

        const priceString = $.number(calculatedPrice,
            this.cultureInfo.currencyDecimalDigits,
            this.cultureInfo.currencyDecimalSeparator,
            this.cultureInfo.currencyGroupSeparator);

        return priceString;
    }

    GetPriceString(totalAmount: number) {
        return $.number(totalAmount,
            this.cultureInfo.currencyDecimalDigits,
            this.cultureInfo.currencyDecimalSeparator,
            this.cultureInfo.currencyGroupSeparator);
    }

    GetPriceStringWithCurrencySymbol(totalAmount: number): string {
        let currencyString = `${this.cultureInfo.CurrencyPosition == 0 ? this.usedCurrencySymbol : ''}${this.GetPriceString(totalAmount)}${this.cultureInfo.CurrencyPosition == 1
            ? this.usedCurrencySymbol
            : ''}`;

        return currencyString;
    }

    GetPrice(price: number): number {
        return price / 100;
    }
}